import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Cookies } from 'react-cookie';
import { Link, useNavigate, useParams } from 'react-router-dom'
import Loading from '../Loading';
import { ErrorAlert, SuccessAlert } from '../middleware/AlertMsg';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,TablePagination
  } from '@mui/material';
import {HeaderTableCell,StyledTableRow,StyledTableCell} from '../Partials/TableStyle'

export const ApproveRefillRequest = () => {
    const { id } = useParams();
    const [isloading, setLoading] = useState(false);
    const [request, setRequest] = useState();
    const cookies = new Cookies();
    const token = cookies.get('JWTcookie');
    const navigate = useNavigate();
    // const baseUrl='https://busy-erin-raven-vest.cyclic.app';
   // const baseUrl = "https://officejeeves.com";
    const baseUrl =  process.env.REACT_APP_BASE_URL;
    // console.log('token: ', token);
    const [sales, setSales] = useState({
        cash: 0,
        totalSalesCount: "",
        totalSalesValue: ""
    })
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [searchQuery, setSearchQuery] = useState("");
    
    const getRequests = async (id) => {
        try {
            setLoading(true);
            const res = await axios.get(`${baseUrl}/api/refillRequest/${id}`, { headers: { 'Authorization': 'Bearer ' + token } })
            const data = res.data.data;
            // console.log('data: ', data);
            setRequest(data);
            setSales(data.sales);
            setLoading(false);
        } catch (error) {
            // console.log(error);
            ErrorAlert({
                title: "Fail",
                message: error.message,
            });
        }
    }

    useEffect(() => {
        getRequests(id);
    }, [id]);

    // to approve the refill request 
    const handleApprove = async (requestNumber) => {
        try {
            setLoading(true);
            const res = await axios.post(`${baseUrl}/api/approverefillrequest/${requestNumber}`,
                {}, { headers: { 'Authorization': `Bearer ${token}` } })
            const data = res.data
            // console.log('data: ', data);
            if (data.success) {
                SuccessAlert({
                    title: "Success",
                    message: "Approved successfully",
                });
                setLoading(false);
                navigate("/managerefillrequest")
            } else {
                setLoading(false);
                ErrorAlert({
                    title: "Fail",
                    message: data.msg,
                });
                navigate("/managerefillrequest")
            }
        } catch (error) {
            ErrorAlert({
                title: "Fail",
                message: error.message,
            });
            setLoading(false);
        }

    }
     // table related functions
  useEffect(() => {
    // Reset page to 0 after a search
    setPage(0);
  }, [searchQuery]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

//   const filteredData = request.filter((item) => {
//     return Object.values(item)
//       .join(" ")
//       .toLowerCase()
//       .includes(searchQuery.toLowerCase());
//   });
 // end table related functions
    const fields = [
        "Slot Name",
        "Product",
        "Closing Stock",
        "Current Stock",
        "Refill Qty",
        "Sale Qty",
    ]
    return (
        <div>
            {isloading ? <Loading /> :
                <div>
                    <div
                        style={{ width: "90%", margin: "auto", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                        <div style={{
                            display: 'flex', justifyContent: 'flex-start', backgroundColor: "black", color: "white", padding: "7px", gap: "10px"
                        }} >
                            <p>Machine Name:</p>
                            <p>{request?.machineId?.machinename}</p>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: "10px" }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: "10px" }}>
                                <p>Status:</p>
                                <div
                                    style={{
                                        backgroundColor: request?.status === "Pending" ? "red" : "green",
                                        padding: '5px',
                                        width: '15px',
                                        height: "15px",
                                        borderRadius: "50%"
                                    }}
                                >
                                </div>
                                {request?.status === "Pending" &&
                                    <Link className="input-lable-v-div" to={`/refillerrefillingrequest/edit/${id}`}>
                                        <button className="submit-btn" style={{ margin: '0' }} >Edit</button>
                                    </Link>
                                }
                            </div>
                        </div>
                    </div>
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <StyledTableRow>
                                    <HeaderTableCell>Slot Name</HeaderTableCell>
                                    <HeaderTableCell>Product</HeaderTableCell>
                                    <HeaderTableCell>Closing Stock</HeaderTableCell>
                                    <HeaderTableCell>Current Stock</HeaderTableCell>
                                    <HeaderTableCell>Refill Qty</HeaderTableCell>
                                    <HeaderTableCell>Sale Qty</HeaderTableCell>
                                </StyledTableRow>
                             </TableHead>
                            <TableBody>
                                {request?.machineSlots.sort((a, b) => a.slot.localeCompare(b.slot))
                                    .map((item, index) => (
                                        <StyledTableRow key={item.id} sx={{
                                            backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                                        }}>
                                            <StyledTableCell>{item.slot}</StyledTableCell>
                                            <StyledTableCell>{item.productid.productname}</StyledTableCell>
                                            <StyledTableCell align='right'>{item.closingStock}</StyledTableCell>
                                            <StyledTableCell align='right'>{item.currentStock}</StyledTableCell>
                                            <StyledTableCell align='right'>{item.refillQuantity}</StyledTableCell>
                                            <StyledTableCell align='right'>{item.saleQuantity}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {/* if return Items array containing return Items then this is rendering */}

                    {request?.returnItems.length > 0 ?
                        <div>
                            <div style={{
                                width: "90%", display: 'flex', margin: "auto", justifyContent: 'flex-start', marginTop: "15px",
                                backgroundColor: "black", color: "white", padding: "7px"
                            }}>
                                <p>Return Items :</p>
                            </div>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <StyledTableRow>
                                            <HeaderTableCell>Slot Name</HeaderTableCell>
                                            <HeaderTableCell>Product</HeaderTableCell>
                                            <HeaderTableCell>Closing Stock</HeaderTableCell>
                                            <HeaderTableCell>Current Stock</HeaderTableCell>
                                            <HeaderTableCell>Refill Qty</HeaderTableCell>
                                            <HeaderTableCell>Sale Qty</HeaderTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {request?.returnItems
                                            .map((item, index) => (
                                                <StyledTableRow key={item.id} sx={{
                                                    backgroundColor: index % 2 === 0 ? '#f5f5f5' : 'white',
                                                }}>
                                                    <StyledTableCell>{item.slot}</StyledTableCell>
                                                    <StyledTableCell>{item.productid.productname}</StyledTableCell>
                                                    <StyledTableCell align='right'>{item.closingStock}</StyledTableCell>
                                                    <StyledTableCell align='right'>{item.currentStock}</StyledTableCell>
                                                    <StyledTableCell align='right'>{item.refillQuantity}</StyledTableCell>
                                                    <StyledTableCell align='right'>{item.saleQuantity}</StyledTableCell>
                                                </StyledTableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>

                        :
                        <div></div>
                    }
                    <div className="cashContainer">
                        <label>Cash:</label>
                        <input
                            placeholder="Enter Cash value"
                            type="number" min={0}
                            value={sales.cash}
                            readOnly
                        />

                        <label>Total Sales Count:</label>
                        <input
                            placeholder="Enter Sales count"
                            type="number" min={0}
                            value={sales.totalSalesCount}
                            readOnly
                        />
                        <label>Total Sales Value:</label>
                        <input
                            placeholder="Enter Sales value"
                            type="number" min={0}
                            value={sales.totalSalesValue}
                            readOnly
                        />
                    </div>
                    <div className="input-lable-v-div">
                        {request?.status === "Pending" ?
                            <button className="submit-btn" onClick={() => handleApprove(request.refillRequestNumber)}>Approve</button>
                            : ""
                        }
                    </div>
                </div>
            }
        </div>
    )
}
